import React from "react";
import ids from "../../ids";


export default ({...props}) => {
  if (!props.style)
    props.style = {height: '64px'};
  return <div id={ids.navbar} {...props}/>
}